module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/amex@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/amex@2x.png
// module id = 1152
// module chunks = 0